// extracted by mini-css-extract-plugin
export default {"chatOutcomeCell":"ChatOutcomeCell_chatOutcomeCell__ddhTg","tooltipContent":"ChatOutcomeCell_tooltipContent__6GPtq","infoIcon":"ChatOutcomeCell_infoIcon__6UWqD"};